export default __webpack_public_path__ + "static/media/vip_icon.67fd284a.svg";